import { useEffect, useState } from "react";
import Main from "../components/admin/Main";
import PageContainer from "../components/admin/PageContainer";
import Modal from "../components/admin/Modal";
import CollapseCard from "../components/admin/CollapseCard";
import GoldRateForm from "../components/admin/GoldRateForm";
import GoldRateList from "../components/admin/GoldRateList";
import {
  fetchGoldRate,
  createGoldRate,
  updateGoldRate,
  deleteGoldRate,
} from "../service/GoldRateService";
import { ToastTypes, useToast } from "../components/toast/ToastProvider";

const GoldRatePage = () => {
  const [showModal, setShowModal] = useState(false);
  const [goldRateData, setGoldRateData] = useState([]);
  const [selectedGoldRate, setSelectedGoldRate] = useState(null);
  const toast = useToast();

  // Fetch gold rates
  const fetchData = async () => {
    try {
      const res = await fetchGoldRate();
      setGoldRateData(res);
    } catch (error) {
      console.error("Failed to fetch gold rates:", error);
      toast("Failed to load gold rates", ToastTypes.ERROR);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Handle Save (Create or Update)
  const handleSave = async (formData) => {
    try {
      if (selectedGoldRate) {
        await updateGoldRate(selectedGoldRate.id, formData);
        toast("Gold rate updated successfully");
      } else {
        await createGoldRate(formData);
        toast("Gold rate added successfully");
      }

      // Refresh list
      fetchData();
      setShowModal(false);
      setSelectedGoldRate(null);
    } catch (error) {
      console.error("Failed to save gold rate:", error);
      toast("Failed to save gold rate", ToastTypes.ERROR);
    }
  };

  // Handle Delete
const handleDelete = async (id) => {
  const confirmed = window.confirm("Are you sure you want to delete this gold rate?");
  if (!confirmed) return;

  try {
    await deleteGoldRate(id);
    fetchData();
    toast("Gold rate deleted successfully");
  } catch (error) {
    console.error("Failed to delete gold rate:", error);
    toast("Failed to delete gold rate", ToastTypes.ERROR);
  }
};


  // Handle Edit
  const handleEdit = (data) => {
    setSelectedGoldRate(data);
    setShowModal(true);
  };

  return (
    <Main>
      <PageContainer
        title="Gold Rate Page"
        buttonText="ADD"
        onButtonClick={() => {
          setSelectedGoldRate(null);
          setShowModal(true);
        }}
      >
        {/* Add/Edit Modal */}
        <Modal
          visible={showModal}
          size="lg"
          onClose={() => {
            setShowModal(false);
            setSelectedGoldRate(null);
          }}
          headerText={selectedGoldRate ? "Edit Gold Rate" : "Add Gold Rate"}
          centered
        >
          <GoldRateForm
            initialValues={selectedGoldRate}
            onSubmit={handleSave}
            onCancel={() => {
              setShowModal(false);
              setSelectedGoldRate(null);
            }}
          />
        </Modal>

        {/* Gold Rate List */}
        <CollapseCard title="Gold Rate List">
          <GoldRateList
            goldRateData={goldRateData}
            onEdit={handleEdit}
            onDelete={handleDelete}
          />
        </CollapseCard>
      </PageContainer>
    </Main>
  );
};

export default GoldRatePage;